import Vue from 'vue'
import VueRouter from 'vue-router'
import DefaultLayout from '@/layouts/defaultLayout'

Vue.use(VueRouter)
function propsResolver(p){
  return {...p.query, ...p.props, ...p.params}
}

const routes = [
  {
    path: '/',
    component: DefaultLayout,
    children: [
      {
        path: '',
        name: 'Home',
        meta: {
          menu: {
            hide: true
          }
        },
        component: () => import(/* webpackChunkName: "Bigdata" */ '@/views/Home')
      },
      {
        path: 'big-data',
        name: 'BigData',
        meta: {
          menu: {
            icon: 'mdi-database',
          }
        },
        component: () => import(/* webpackChunkName: "Bigdata" */ '@/views/Bigdata')
      },
      {
        path: 'manage-data',
        name: 'ManageData',
        meta: {
          menu: {
            icon: 'mdi-auto-fix',
          }
        },
        component: () => import(/* webpackChunkName: "Manage" */ '@/views/Manage')
      },
      {
        path: 'mileage',
        name: 'Mileage',
        meta: {
          menu: {
            icon: 'mdi-cash-100',
          }
        },
        component: () => import(/* webpackChunkName: "mileage" */'@/views/Mileage')
      },
      {
        path: 'game',
        name: 'Games',
        meta: {
          menu: {
            icon: 'mdi-controller',
          }
        },
        component: () => import(/* webpackChunkName: "Game" */ '../views/Games')
      },
      {
        path: 'game/:id',
        props: propsResolver,
        name: 'Game',
        component: () => import(/* webpackChunkName: "Game" */ '../views/Game')
      },
      {
        path: 'user',
        name: 'User',
        meta: {
          menu: {
            text: 'My Account',
            icon: 'mdi-account',
          }
        },
        component: () => import(/* webpackChunkName: "User" */ '../views/User')
      },
      {
        path: 'deploy',
        name: 'Deploy',
        meta: {
          menu: {
            icon: 'mdi-account-hard-hat',
            hide: function() {
              // console.debug(this, this.isAdmin)
              return !this.isAdmin
            }
          }
        },
        component: () => import(/* webpackChunkName: "deploy" */ '../views/Deploy')
      },

    ]
  },
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  mode: "history",
  routes
})

export default router
